module.exports = __webpack_public_path__ + "static/img/dytb1-4.3fdbf06.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/dytb1-4.png
// module id = 940
// module chunks = 0